export enum HTMLTypeBaseVariableId {
  OBSERVATIONS = 'observations',
  RECIPIENTS = 'recipients',
  RPPS_BARCODE = 'rppsBarcode',
  FINESS_BARCODE = 'finessBarcode',
  PATIENT_INS_QRCODE = 'insQrcode',
  SIGNATURE = 'signature',
}
